module.exports = __webpack_public_path__ + "img/chevron-logo.dd26219b.jpg";